import styled from 'styled-components'
import { AspiraRegular } from '@chegg-wt/core/theme/sunkist/fonts'

export const Alert = styled.div`
  ${AspiraRegular}
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 4px;
  background: #ec5b5b;
  color: #fff;
  font-size: 13px;
  padding: 15px;
  margin: 15px 10px 15px 10px;
  border-radius: 3px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  background-color: #f2dede;
  border-color: #ebccd1;
  color: #a94442;
`
